module.exports = __webpack_public_path__ + "static/media/schedules.1e59c423.svg";